import script from "./Ability.vue?vue&type=script&setup=true&lang=js"
export * from "./Ability.vue?vue&type=script&setup=true&lang=js"

import "./Ability.vue?vue&type=style&index=0&id=b4ee7f46&scoped=true&lang=css"

import exportComponent from "D:\\CY_selflearning\\self-learning\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4ee7f46"]])

export default __exports__